// js
import React from 'react';
import PropTypes from 'prop-types';
import { Snackbar } from '@its-svp/svp-common-ui';
import '../../styles/components/common/ConvertTrainingSnackbar.scss';

const ConvertTrainingSnackbar = (props) => {
  const { assessment, dismiss, maybeShow, onConvertDSA } = props;

  const assessmentAge = (new Date()) - Date.parse(assessment.createdAt);

  // early exit if not a test asmt, too new (1 day), or dismissed
  if (!assessment.is_test || assessmentAge < 86400000 || !maybeShow) {
    return null;
  }

  const content = (
    <div>
      <a onClick={() => {
        dismiss();
        onConvertDSA();
      }}>Click here</a> to convert this Training assessment,
      which will enable linking to relevant Opportunities and remove
      the watermark from the PowerPoint output to facilitate use with your customer.
    </div>
  );

  return (
    <div className='svp-common-ui convert-training-snackbar-component'>
      <Snackbar status='warning' content={content} onClose={dismiss} />
    </div>
  );
};

ConvertTrainingSnackbar.defaultProps = {
  maybeShow: true
};

ConvertTrainingSnackbar.propTypes = {
  assessment: PropTypes.shape({
    createdAt: PropTypes.string.isRequired,
    is_test: PropTypes.bool.isRequired
  }),
  dismiss: PropTypes.func.isRequired,
  maybeShow: PropTypes.bool,
  onConvertDSA: PropTypes.func
};

export default ConvertTrainingSnackbar;



// WEBPACK FOOTER //
// ./src/components/common/ConvertTrainingSnackbar.js